import ".././styles/Footer.css";
import pccmlogo from ".././assets/pccm_logo.png";
import instagramlogo from ".././assets/instagram-logo.png";
import facebooklogo from ".././assets/facebook-logo.png";
import {Link} from "react-router-dom";
function Footer() {
    return (
        <>
            <div class="footer-wrapper">
                <div class="footer">
                    <div class="footer-labels">
                        <div class="left-side">
                            <a href="/"><img class="footer-logo" src={pccmlogo} alt=""></img></a>
                            <div class="text-under-logo">
                                737 Keewatin St, Winnipeg, MB <br></br>R2X 3B9
                            </div>
                        </div>
                        <div class="right-side">
                            <ul class="footer-section">
                                <li class="footer-title">About</li>
                                <li><Link to="/aboutus">Board Members</Link></li>
                                <li><Link to="/aboutus">Conditions & By-Laws</Link></li>
                            </ul>
                            <ul class="footer-section">
                                <li class="footer-title">Community</li>
                                <li><Link to="/events">Events</Link></li>
                                <li><Link to="/news">News</Link></li>
                                <li><Link to="/gallery">Gallery</Link></li>
                                {/* <li><Link to="/memberships">Memberships</Link></li> */}
                            </ul>
                            <ul class="footer-section">
                                <li class="footer-title">Contact</li>
                                <li>Email: contact@thepccm.ca</li>
                                <li>Phone: &#40;204&#41; 775-4928</li>
                                <span class="footer-contacts">
                                    <li><a href="https://www.facebook.com/groups/3555107267913403/"><img src={facebooklogo} class="ig-logo"></img></a></li>
                                    <li><a href="https://www.facebook.com/groups/3555107267913403/"><img src={instagramlogo} class="ig-logo"></img></a></li>
                                </span>
                            </ul>
                        </div>
                    </div>
                    

                </div>
            </div>

            <div class="footer-copyright-wrapper">
                        <div class="footer-copyright copyright-section">
                            <div class="copyright">
                                ©2024 Philippine Canadian Centre of Manitoba. All rights reserved
                            </div>
                            <div class="privacy-terms">
                                <div class="privacy-policy">
                                    Privacy & Policy
                                </div>
                                <div class="terms-conditions">
                                    Terms & Conditions
                                </div>
                            </div>
                        </div>
                    </div>
        </>
    );
}

export default Footer;